import { useEffect } from 'react';
import { useWorldStore } from '../state/worldStore';
import { listWorldObjects } from '../services/worldObjects';

// RoomConfigs — every room's saved settings, fetched ONCE at start-up.
//
// These were loaded per-room by MeshInterior, on entry, which is a frame or two
// too late for the one thing that matters most: the camera is placed the instant
// you enter, from `ROOMS[interior].spawn`, and the saved spawn arrived after it
// had already flown there and settled. The result was landing at the room's
// authored default every single time, no matter how carefully the real spawn had
// been measured and saved — a race, not a save failure, which is why it looked
// like the setting was being ignored rather than lost.
//
// Loading the lot up front costs one small request for the whole world and makes
// the answer synchronous at the moment it is needed. There is one row per tuned
// room and rooms are counted in tens, so this does not grow into a problem.
export default function RoomConfigs() {
  const setRoomConfig = useWorldStore((s) => s.setRoomConfig);

  useEffect(() => {
    let dead = false;
    listWorldObjects(null, 'room_config').then((rows) => {
      if (dead || !rows?.length) return;
      for (const r of rows) {
        if (!r.zone_id) continue;
        setRoomConfig(r.zone_id, { objectId: r.object_id, ...(r.data || {}) });
      }
      console.log(`[venue] loaded saved settings for ${rows.length} room(s): ${rows.map((r) => r.zone_id).join(', ')}`);
    });
    return () => { dead = true; };
  }, [setRoomConfig]);

  return null;
}
